export const environment = {
  production: false,
  environment: 'test',
  apiUrl: 'https://5uf5lxixgb.execute-api.us-west-1.amazonaws.com/test',
  readOnlyMode: false,
  cognito: {
    userPoolId: 'us-west-1_4MMm1y7PY',
    userPoolClientId: '204v55vlrtl3bddc6pa3kssole',
    identityPoolId: 'us-west-1:2ae4597d-c591-46bc-bef2-ab8d0eb2df16',
    region: 'us-west-1'
  },
  stripe: {
    publishableKey: 'pk_test_307TzlVD9fhA6Wuk86onOlOw00r25LRgEc'
  },
  testing: {
    // Override early bird deadline for testing (ISO string)
    // Set to null to use server data
    // Example: '2025-01-15T18:00:00Z' for testing expiration
    //earlyBirdDeadlineOverride: '2025-09-03T21:18:00Z'
    //earlyBirdDeadlineOverride: '2025-09-04T05:07:00Z'
    earlyBirdDeadlineOverride: null
  }
};